import { Button, Col, Flex } from "antd";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";

import { CommonTable } from "components";
import { useStores } from "stores";
import { routes } from "constants/routes";
import { StatusFilters } from "./StatusFilters";
import { getColumns } from "./getColumns";
import { shouldShowResetButton } from "utils";
import { useEffect } from "react";

export const PendingActionsBids = observer(() => {
  const { pendingActionsBidList, user, fiatCurrencyList } = useStores();
  const navigate = useNavigate();

  const {
    isRiskManager,
    isSeniorOperator,
    isJuniorOperator,
    isJuniorLP,
    isSeniorLP,
    isLPRiskManager,
    isJuniorCustomer,
    isSeniorCustomer,
  } = user.roles;

  const canGoToCard =
    isRiskManager ||
    isSeniorOperator ||
    isJuniorOperator ||
    isJuniorLP ||
    isSeniorLP ||
    isLPRiskManager ||
    isJuniorCustomer ||
    isSeniorCustomer;

  useEffect(() => {
    if (!fiatCurrencyList?.currencyMap?.length) {
      fiatCurrencyList.onChangeDataFlow({}, { initialize: true });
    }
  }, []);

  return (
    <Flex vertical gap="large" className="margin-top-xs">
      <CommonTable
        id="pending-actions-bids-table"
        store={pendingActionsBidList}
        updateWithInterval
        columns={getColumns(pendingActionsBidList, user, fiatCurrencyList)}
        onRow={(record) => ({
          onClick: canGoToCard ? () => navigate(`/${routes.bids}/${record.id}`) : undefined,
          className: canGoToCard ? "cursor-pointer" : "",
        })}
        whiteBox
        removeButtonAlign="start"
        customShouldShowResetButton={() => shouldShowResetButton(pendingActionsBidList, ["status"])}
        additionalElements={
          <Col id="pending-actions-bids-status-filters">
            <StatusFilters />
          </Col>
        }
        widgets={{
          date: true,
          search: true,
        }}
        hintsIds={{ search: "pending-actions-bids-search" }}
      />
    </Flex>
  );
});
